import { RootState } from 'redux/store';

export const getHsCodesItems = (state: RootState) => state.hscodes.hscodes?.items || [];
export const getHsCodesLoading = (state: RootState) => state.hscodes.hscodesLoading;

export const getManualHsCodesItems = (state: RootState) => state.hscodes.manualHsCodes?.items || [];
export const getManualHsCodesLoading = (state: RootState) => state.hscodes.manualHsCodesLoading;
